export enum VariantTypeEnum {
  Classic = 'classic',
  Smart = 'smart',
  Premium = 'premium',
}
